import { ButtonLink } from "@teamscheme/button-link";
import { useState, ReactNode } from "react";
import Modal from "../../shared/Modal";
import { ContractUpdate } from "./ContractUpdate";
import { ContractUpdatesList } from "./ContractUpdatesList";

type OpenCallback = (buttonEl: HTMLButtonElement) => void;

interface RenderChildrenParams {
  open: OpenCallback;
}

export default function ContractUpdatesModal({
  updates,
  children,
  onRead,
}: {
  updates: ContractUpdate[];
  children(params: RenderChildrenParams): ReactNode;
  onRead(): void;
}) {
  const [buttonEl, setButtonEl] = useState<{
    current: HTMLButtonElement;
  } | null>(null);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {children({
        open: (buttonEl) => {
          setButtonEl({ current: buttonEl });
          setIsOpen(true);
        },
      })}
      <Modal
        isOpen={isOpen}
        button={buttonEl}
        onClose={() => setIsOpen(false)}
        title="Endringer"
      >
        <ContractUpdatesList updates={updates} />
        <ButtonLink
          variant="secondary"
          onClick={() => {
            onRead();
            setIsOpen(false);
          }}
        >
          Lukk
        </ButtonLink>
      </Modal>
    </>
  );
}
